// Индикатор статуса, различимый без цвета (D-11, WCAG 1.4.1).
// Source: docs/specs/design-revision/d-design-system.md §3.
//
// Заменяет цветной кружок в трёх местах: точка категории в каталоге, точка
// органа, точка на карточке показателя. Кружок был одинаковой формы во всех
// четырёх состояниях — то есть для человека, не различающего красный и
// зелёный, он не нёс ничего.
//
// В строке истории измерений глифа НЕТ: там есть место для слова, и слово
// читается лучше значка (R-10).

import { cn } from '@/lib/utils';
import { GLYPH_TEXT_BY_TIER, STATUS_GLYPH_BY_TIER, type DisplayTier } from '@/lib/biomarkerStatus';

export function StatusGlyph({ tier, className }: { tier: DisplayTier; className?: string }) {
  const { glyph, label } = STATUS_GLYPH_BY_TIER[tier];

  return (
    <span
      role="img"
      aria-label={label}
      className={cn(
        'flex-shrink-0 select-none text-hl-small leading-none',
        GLYPH_TEXT_BY_TIER[tier],
        className,
      )}
    >
      {glyph}
    </span>
  );
}
